module.exports = __webpack_public_path__ + "static/media/ThebanCitizen.f4b1ac76.jpg";